var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.59961 5.19961C8.59961 5.53098 8.33098 5.79961 7.99961 5.79961C7.66824 5.79961 7.39961 5.53098 7.39961 5.19961C7.39961 4.86824 7.66824 4.59961 7.99961 4.59961C8.33098 4.59961 8.59961 4.86824 8.59961 5.19961Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99961 6.59961C8.33098 6.59961 8.59961 6.86824 8.59961 7.19961V10.7996C8.59961 11.131 8.33098 11.3996 7.99961 11.3996C7.66824 11.3996 7.39961 11.131 7.39961 10.7996V7.19961C7.39961 6.86824 7.66824 6.59961 7.99961 6.59961Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3996 7.99961C14.3996 11.5342 11.5342 14.3996 7.99961 14.3996C4.46499 14.3996 1.59961 11.5342 1.59961 7.99961C1.59961 4.46499 4.46499 1.59961 7.99961 1.59961C11.5342 1.59961 14.3996 4.46499 14.3996 7.99961ZM13.1996 7.99961C13.1996 10.8715 10.8715 13.1996 7.99961 13.1996C5.12773 13.1996 2.79961 10.8715 2.79961 7.99961C2.79961 5.12773 5.12773 2.79961 7.99961 2.79961C10.8715 2.79961 13.1996 5.12773 13.1996 7.99961Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoSmall);
export default __webpack_public_path__ + "static/media/infoSmall.49cb7749f0e148e0a9d865fc091779b0.svg";
export { ForwardRef as ReactComponent };